import { useRef, useState } from 'react';
import { Slot, VersionCheck, UList } from './styles';
import { useOutsideDrop } from '../../../../../../hooks/useOutsideDrop';

import ArrowDownGreen from '../../../../../../assets/icons/ArrowDownGreen';
import Check from '../../../../../../assets/icons/Check';
import Popper from '../../../../Popper/index';

export function Dropdown({ flows, onSelect, selected }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const onClose = () => setOpen(false);
  useOutsideDrop(containerRef, onClose);

  return (
    <Slot
      onClick={() => {
        if (flows.length > 1) setOpen((prev) => !prev);
      }}
      ref={containerRef}
      open={open}
    >
      {selected.title}
      <Popper isOpen={open} onClose={onClose} anchorRef={containerRef}>
        <UList>
          {flows.map((item, index) => (
            <li
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                onSelect({
                  _id: item._id,
                  title: item.title,
                });
              }}
            >
              {item.title}
              {item._id === selected._id ? (
                <VersionCheck>
                  <Check height={'1rem'} />
                </VersionCheck>
              ) : null}
            </li>
          ))}
        </UList>
      </Popper>
      <ArrowDownGreen />
    </Slot>
  );
}
